import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

/** The index advisor's page (in the Operations group, right after Databases). */
export const INDEX_ADVISOR_NAV: NavNode[] = [
  {
    path: '/databases/index-advisor',
    label: 'Index advisor',
    requires: SCOPES.dbRead,
    description:
      'Indexes the database advisor recommends across tenant databases, reviewed against the default set.',
  },
];
